import { Store } from '@reduxjs/toolkit';
import { AxiosInstance, AxiosRequestHeaders, AxiosStatic } from 'axios';
import { HEADER_CENTRE, HEADER_COUNTRY, HEADER_LOCATION, HEADER_ORGANISATION } from 'const';
import { getNavigationContext, NavigationContext, RootState } from 'store';

export function includeNavigationContextInterceptor(
  axios: AxiosInstance | AxiosStatic,
  store: Store<RootState>
) {
  axios.interceptors.request.use(function (config) {
    if (!config.headers) {
      return config;
    }
    includeNavigationHeaders(
      { navigation: getNavigationContext(store.getState()) },
      config.headers
    );
    return config;
  });
}

export const includeNavigationHeaders = (
  { navigation }: { navigation: NavigationContext },
  headers: AxiosRequestHeaders
) => {
  if (navigation.organisationId) {
    headers[HEADER_ORGANISATION] = navigation.organisationId;
  }
  if (navigation.countryId) {
    headers[HEADER_COUNTRY] = navigation.countryId;
  }
  if (navigation.centreId) {
    headers[HEADER_CENTRE] = navigation.centreId;
  }
  if (navigation.locationId) {
    headers[HEADER_LOCATION] = navigation.locationId;
  }
};
